import request from '@/utils/sap-request'

// 营销单元刷新批导查询
export const getSaleCenterUpdateList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_yxdy_sx_pd',
    method: 'POST',
    data
  })
}

// 营销单元刷新批导查询
export const getSaleCenterUpdateListDetail = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_yxdy_sxpdmx',
    method: 'POST',
    data
  })
}

// 营销单元刷新批导明细保存、取消。
export const apiSaleCenterImportBatchAction = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/yxdy_sx_pd_mx',
    method: 'POST',
    data
  })
}

// 营销单元刷新批导。
export const apiSaleCenterImport = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/yxdy_sx_import',
    method: 'POST',
    data
  })
}

// 制票通知单日期特殊修改。
export const apiUpdateInvoiceDate = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/zhipiao14',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sap/system-settings.js